import { BFScreen } from "@/components/standard/screen/BFScreen"
import { Body, H2, H5 } from "@/components/standard/BFText"
import { VerticalTimeline } from "@/components/timeline/VerticalTimeline"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { AppleStoreDownloadButton } from "@/components/buttons/AppleStoreDownloadButton"
import { PlayStoreDownloadButton } from "@/components/buttons/PlayStoreDownloadButton"
import { Container } from "@/screens/rewards/components/Container"

export default function PublicSoftCreditPollScreen() {
  return (
    <BFScreen
      headerSticky={false}
      dark={false}
      className={"p-5"}
      noBackButton={true}
    >
      <Vertical className={"p-4 items-center gap-4 mb-5"}>
        <H2>Thanks</H2>
        <Body className={"text-center"}>
          Your soft credit pull has been initiated. Here’s what you can expect
          to happen next:
        </Body>
      </Vertical>
      <Vertical className={"px-5 flex-1 justify-between"}>
        <VerticalTimeline
          items={[
            { title: "Complete soft credit pull", status: "complete" },
            {
              title: "Lock in your terms",
              status: "inprogress",
              description:
                "Our lending team will review the deal and be in touch shortly to finalize your terms",
            },
            {
              title: "Processing kickoff",
              description:
                "You will meet your processor, and your team will work diligently to prepare you for closing",
              status: "todo",
            },
            {
              title: "Cleared to close",
              description: "Receive final approval for closing",
              status: "todo",
            },
            {
              title: "Closing day",
              description: "Time to get your project started!",
              status: "todo",
            },
          ]}
        />
        <Container className={"gap-5 mb-10"}>
          <Body className={"text-center text-midnight-blue"}>
            Follow your loan’s progress
          </Body>
          <H5 className={"text-center text-midnight-blue"}>
            Download the Backflip App
          </H5>
          <Horizontal className="flex justify-evenly shrink-0 items-center">
            <AppleStoreDownloadButton onPress={() => {}} />
            <PlayStoreDownloadButton onPress={() => {}} />
          </Horizontal>
        </Container>
      </Vertical>
    </BFScreen>
  )
}
